// extracted by mini-css-extract-plugin
export default {"content":"Content-module__content__35g8T","list":"Content-module__list__CLkst","title":"Content-module__title__1nbiS"};